export default __webpack_public_path__ + "cadc34eca18cdb98a3bd6a58febf7be4.png";